import { useRef, useState, useEffect } from 'react';
import TextBoxNumericControl from "../../../Controls/TextBoxNumericControl"
import TextBoxControl from "../../../Controls/TextBoxControl"
import ButtonControl from "../../../Controls/ButtonControl"
import { useNavigate } from "react-router-dom";
import TextAreaControl from "../../../Controls/TextAreaControl";
import Button from 'react-bootstrap/Button';
import SelectControl from "../../../Controls/SelectControl"
import DatePickerControl from "../../../Controls/DatePickerControl"
import { toast } from 'react-toastify';

import { 
	GetLocal,
	SetLocal,
	FetchService,
	IsEmptyInput,
	ConvertCharacterDate
} from "../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../Base/BasePageEmployee';

let ServiceUrlCheckBox = '';

export default function Index(props) {
    const inputRef = useRef(null);
	const navigate = useNavigate();

	const inpDescriptionRef = useRef(null);
	
    const [value, setValue] = useState(0);
	const [getShowModal, setShowModal] = useState(false);
	const inpTelRef = useRef(null);
	const [getServiceResult, setServiceResult] = useState(false);
	const [getSelectData, setSelectData] = useState([]);
	const [getFileNumberState,setFileNumberState] = useState(true);
	const [getSelectDisabledData, setSelectDisabledData] = useState(true);
	const valueFromDateRef = useRef(null);
	const valueToDateRef = useRef(null);
	
    useEffect(() => {
		SetTypeLevel('GetConstructionReportByAllType');
		
		var inputValue = {};		
        FetchService("General/Abstract/ShowConstructionTypeAbstractList", inputValue, ShowConstructionTypeAbstractListSuccess);		
    }, []);

	const ShowConstructionTypeAbstractListSuccess =(ServiceResult)=>{
		setSelectData(ServiceResult.ConstructionTypeInfo);
	}	
	
	const GetConstructionReportBySingleType = ()=>{
		if(IsEmptyInput(inputRef))
			return false;
		
        var inputValue = {
			session: GetLocal('EmployeeSession'),
			fromDate: ConvertCharacterDate(valueFromDateRef.current.firstChild.defaultValue),
			toDate: ConvertCharacterDate(valueToDateRef.current.firstChild.defaultValue),
			ConstructionType: inputRef.current.value
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Request/GetConstructionReportBySingleType", inputValue, GetCertificateReportBySingleTypeSuccess);		
	}
	
	const GetCertificateReportBySingleTypeSuccess =(ServiceResult)=>{
		//setServiceResult(ServiceResult);
		var a = document.createElement("a");
		var data_type = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,';
		a.href = data_type + ServiceResult;
		a.download = "گزارش پروانه.xls";
		a.click();		
	}
	
	const GetConstructionReportByAllType = ()=>{		
        var inputValue = {
			  session: GetLocal('EmployeeSession'),
			  fromDate: ConvertCharacterDate(valueFromDateRef.current.firstChild.defaultValue),
			  toDate: ConvertCharacterDate(valueToDateRef.current.firstChild.defaultValue)		  
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Request/GetConstructionReportByAllType", inputValue, GetCertificateReportByAllTypeSuccess);		
	}
	
	const GetCertificateReportByAllTypeSuccess =(ServiceResult)=>{
		//setServiceResult(ServiceResult);
		var a = document.createElement("a");
		var data_type = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,';
		a.href = data_type + ServiceResult;
		a.download = "گزارش پروانه.xls";	
		a.click();		
	}	
	
	const ClearRefInput = ()=>{
		inputRef.current.value = ""; 
	}		
	
	const SetTypeLevel =(val)=>{
		ServiceUrlCheckBox = val;
		setServiceResult([]);

		if(val == 'GetConstructionReportBySingleType'){
			setFileNumberState(false);
			setSelectDisabledData(false);
		}
		else{
			setFileNumberState(true);	
			setSelectDisabledData(true);
		}
	}
	
	const BtnGetServiceResult = ()=>{
		if(ServiceUrlCheckBox == 'GetConstructionReportByAllType')
			GetConstructionReportByAllType();
		
		if(ServiceUrlCheckBox == 'GetConstructionReportBySingleType')
			GetConstructionReportBySingleType();
	}	

    return (
		<div class="text-center my-4">
			<table dir="rtl" className="col col-sm-12 col-md-6">
				<tbody>
				<tr>
					<td style={{"width": "17px"}}><input onClick={()=>SetTypeLevel('GetConstructionReportByAllType')} checked={getFileNumberState == 1} type="radio" name="FilesRadio" className="align-bottom" /></td>
					<td style={{"width": "10px"}}>کلیه انواع</td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
				</tr>
				<br/>				
				<tr>
					<td style={{"width": "10%"}}><input onClick={()=>SetTypeLevel('GetConstructionReportBySingleType')} checked={getFileNumberState == 0} type="radio" name="FilesRadio" className="align-bottom" /></td>
					<td style={{"width": "30%"}}>یک نوع خاص</td>
					<td style={{"width": "100%"}}>
						<SelectControl disabled={getSelectDisabledData} data={getSelectData} inputRef={inputRef}/>				
					</td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
				</tr>	
				<br/>	
				<tr>
					<td style={{"width": "10%"}}></td>
					<td style={{"width": "30%"}}>از تاریخ:</td>
					<td style={{"width": "100%"}}>
						<DatePickerControl value="" inputRef={valueFromDateRef}/>				
					</td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
				</tr>	
				<br/>	
				<tr>
					<td style={{"width": "10%"}}></td>
					<td style={{"width": "30%"}}>تا تاریخ:</td>
					<td style={{"width": "100%"}}>
						<DatePickerControl value="" inputRef={valueToDateRef}/>				
					</td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
				</tr>				
				<br/>	
				<tr>
					<td colspan="7" className="text-end">
						<ButtonControl 
							variant="primary float-left w-25 mx-2"
							title="دانلود گزارش"
							onClick={BtnGetServiceResult}
							icon="fa fa-search"
						/>						
					</td>
				</tr>	
				</tbody>
			</table>
			
			<hr/>
			{getServiceResult != false && <iframe src={"data:application/pdf;base64,"+getServiceResult} width="100%" height="600"></iframe> }
		</div>
    );
}
